export default {
  accesstoken: null,
  user: null,
  updateProfileDialogVisible: false,
  createProfileDialogVisible: false,
  updateTeamDialogVisible: false,
  loginDialogVisible: false,
  notification: {
    visible: false,
    message: "",
    type: "info"
  },
  teams: {},
  teamLikers: {}
};
